






















































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../main";
import * as user from "../_store/user.module";
import { UserResetPassInfo } from "../_models/userResetPasswordInfo";

@Component
export default class ChangePassword extends Vue {
  @Prop() email!: string;
  @Prop() type!: string;

  dialog: boolean = false;
  userEmail: string = "";
  username: string = "";
  emailRules: [boolean | string] = [true];
  usernameRules: [boolean | string] = [true];

  validazioneEmail() {
    var valid: boolean = false;
    if (this.userEmail !== "") {
      valid = /[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(this.userEmail);
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.userEmail === "") {
      this.emailRules = ["Email Utente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }

  validazioneUsername() {
    if (this.username !== "") {
      this.usernameRules = [true];
    } else {
      this.usernameRules = ["Username necessario"];
    }
  }

  closeDialog(): void {
    // this['$refs.form.reset()']
    this.dialog = false;
  }

  async executeTest() {
    this.validazioneEmail();
  }

  parseToken(token: string): JSON {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  resetPassword() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var rand = function() {
          return Math.random()
            .toString(36)
            .substr(2);
        };
        var token = function() {
          return rand() + rand();
        };
        var payload: UserResetPassInfo;
        if (this.type === "edit") {
          var userToken: string | null = localStorage.getItem("userToken");
          var parsedToken: any;
          if (userToken !== null) {
            parsedToken = this.parseToken(userToken);
            payload = {
              email: this.userEmail,
              token: token(),
              username: parsedToken.Username,
              changeType: "edit"
            };
            user.dispatchSendResetLink(this["$store"], payload).then(() =>{
              this.dialog = false
              bus.$emit("successfullOperation", "Link di reset inviato")
            })
          } else {
            bus.$emit("errorOperation", "Username non valido");
          }
        } else if (this.type === "reset") {
          payload = {
            email: this.userEmail,
            token: token(),
            username: this.username,
            changeType: "reset"
          };
          user.dispatchSendResetLink(this["$store"], payload).then(() => {
            this.dialog = false
            bus.$emit("successfullOperation", "Link di reset inviato")  
          }).catch(error =>{
            // bus.$emit("errorOperation", "Usi");  
          });
        } else {
          bus.$emit(
            "errorOperation",
            "Tipo di cambio non specificato o non riconosciuto"
          );
        }
      }
    });
  }
}
